import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)
export default new Vuex.Store({
    state:{
        activeMenu:'1-1',
        roleId:'',// 1 投标人 2招标代理
    },
    mutations:{
        // 改变当前选中的菜单项
        changedActiveMenu(state,val){
            state.activeMenu = val
        },
        // 改变当前选中的角色
        changedRoleId(state,val){
            state.roleId = val
        },
    },
})